// ----------------------------------------------------------------------

// IF THIS TRANSLATION IS INCORRECT PLEASE IGNORE THIS AS THIS TRANSLATION IS FOR DEMO PURPOSES ONLY
// We are happy if you can help improve the translation by sending an email to support@minimals.cc.

// ----------------------------------------------------------------------

const en = {
  game: `Game`,
  games: `Games`,
  sport: `Sport`,
  center: `Center`,
  mines: `MINES`,
  filters: `Filters`,
  crash: `CRASH`,
  lucky_colour: `LUCKY COLOUR`,
  dice: `DICE`,
  limbo: `LIMBO`,
  lucky_gift: `LUCKY GIFT`,
  all_games: `All Games`,
  game_history: `Game History`,
  coupon_code: `Coupon Code`,
  telegram: `Telegram`,
  customer_service: `Customer Service`,
  player: `Player`,
  winner: `Winner`,
  all_bets: `All Bets`,
  my_bets: `My Bets`,
  name: `Name`,
  time: `Time`,
  bet_amount: `Bet Amount`,
  prediction: `Prediction`,
  payout: `Payout`,
  login: `LOGIN`,
  register: `REGISTER`,
  username_placeholder: `Username`,
  please_input_your_x: `Please Input Your {{x}}`,
  captcha: `CAPTCHA`,
  forgot_password: `Forgot Password`,
  minor_note: `To visit this site, make sure you are over 18 and agree`,
  terms_of_service: `Terms of Service`,
  by_signing_in: 'By Signing In or Signing Up, you agree with our',
  dont_have_account: `Do Not Have An Account Yet?`,
  sign_up: `Sign Up`,
  username: `Username`,
  email: `Email`,
  full_name: `Full Name`,
  confirm_18: `I confirm that I am 18 years old and I have read the`,
  already_have_account: `Already have an account?`,
  share: `Share`,
  deposit: `Deposit`,
  bonus: `Bonus`,
  app: `App`,
  load_more: `Load More`,
  details: `Details`,
  helps: `HELPS`,
  kyc_policy: `KYC Policy`,
  privacy_policy: `Privacy Policy`,
  responsible_gaming: `Responsible gaming`,
  terms_and_condition: `Terms and Condition`,
  faq: `FAQ`,
  about_us: `ABOUT US`,
  amount: `Amount`,
  extra: `Extra`,
  deposit_bonus: `Deposit Bonus`,
  do_not_participate: `Do not participate in promotions`,
  payment_problem: `Payment Problem`,
  click_for_help: `Click for help`,
  deposit_notes: `Deposit Notes`,
  available_balance: `Available Balance`,
  withdraw: `Withdraw`,
  withdrawal_notes: `Withdrawal Notes`,
  withdrawal_note1: `Number of withdrawals in current`,
  withdrawal_note1_1: `vip`,
  withdrawal_note2: `Withdrawal fee:`,
  min: `Min:`,
  max: `Max:`,
  opening_times: `Opening times:`,
  withdrawal_note3: `1.Fastest withdrawal time within 10 minutes`,
  withdrawal_note4: `2.Make sure your withdrawal information is accurate, if the withdrawal information is wrong, it may cause your funds to lose.`,
  withdrawal_note5: `3.Please feel free to contact us if you have any questions.`,
  notifications: `Notifications`,
  invalid_x: `Invalid {{x}}`,
  captcha_not_match: `Captcha Does Not Match`,
  invalid_x_must_be_atleast_y_characters: `Invalid {{x}}, must be atleast {{y}} characters`,
  x_is_required: `{{x}} is required`,
  phone_number: 'Phone Number',
  phone_num_x_max: `Phone Number maximum {{x}} digits`,
  email_sent: `Email sent, please check your email.`,
  enter_valid_email: `Please enter a valid email.`,
  confirm: `Confirm`,
  password_atleast_6_characters: `Password must be atleast 6 characters.`,
  password_reset_success: `Password reset success!.`,
  new_password: `New Password`,
  bank: 'Bank',
  bank_transfer: `Bank Transfer`,
  bank_name: `Bank Name`,
  account_name: `Account Name`,
  account_number: `Account Number`,
  pix_number: `PIX Number`,
  drop_or_select: `Drop or Select file`,
  drop_files_here: `Drop files here`,
  transfer_to: `Transfer To`,
  upload_receipt: `Upload Receipt`,
  select_bonus: `Select Bonus`,
  no_promotion: `No Promotion`,
  please_upload_receipt: `Please upload receipt`,
  bank_account: `Bank Account`,
  bank_branch: `Bank Branch`,
  pay_id: `Pay Id`,
  add_account: `Add Account`,
  account_holder_name: `Account Holder Name`,
  name_of_the_account_holder: `Name of the Account Holder`,
  fill_in_bank_account: `Fill in Bank Account`,
  fill_in_pay_id: `Fill in Pay Id`,
  fill_in_bank_branch: `Fill in Bank Branch`,
  withdraw_information: `Withdraw Information`,
  note: `Note`,
  deposit_from_bank: 'Deposit From Bank',
  amount_withdrawn: `Amount withdrawn`,
  amount_no_exceed_balance: `Withdraw Amount should not exceed the available balance`,
  minimum_withdraw_amount_is_x: `Minimum Withdraw amount is {{x}}`,
  transaction_history: `Transaction History`,
  date_from: `Date From`,
  date_to: `Date To`,
  account_name_must_be_4: `Account Name must be greater than 4 in length`,
  account_number_must_be_x: `Account number must be 10-14 in length`,
  minimum_length_is_x: `Minimum length is {{x}}`,
  maximum_length_is_x: `Maximum length is {{x}}`,
  payment_method: `Payment Method`,
  mode: `Mode`,
  no_bank_account: `You do not have any account to withdraw to, Add now`,
  please_select_bank: `Please select a Bank Account`,

  bet_history: `Bet History`,
  game_provider: `Game Provider`,
  bet_count: `Bet Count`,
  win_loss: `Win/Loss`,
  rebate: `Rebate`,
  turnover: `Turnover`,
  game_category: `Game Category`,

  you_have_x_unread_messages: `You have {{x}} unread messages`,
  deposit_amount_between_x_and_y: `Deposit amount must be between {{x}} and {{y}}`,
  minimum_amount_is_x_y: `Minimum amount is {{x}}{{y}}`,

  // all
  all: `All`,
  title: `Title`,
  date: `Date`,
  type: `Type`,
  status: `Status`,
  remark: `Remark`,
  category: `Category`,
  please_select_x: `Please select {{x}}`,
  save: `Save`,

  change_password: `Change Password`,
  current_password: `Current Password`,
  confirm_password: `Confirm New Password`,
  submit: `Submit`,
  password_changed: `Password Changed`,
  x_must_be_y_characters: `{{x}} must be at least {{y}} characters`,
  reset_password: `Reset Password`,
  back_to_games: 'Back to Games',
  casino: `Casino`,
  slots: `Slots`,
  live_casino: `Live Casino`,
  fishing: `Fishing`,
  sports: `Sports`,
  cards: `Cards`,
  clear: `Clear`,
  search: `Search`,
  new: `New`,
  logout: `Logout`,
  choose_date: `Choose Date`,
  select_both_date: `Select both Date From and To`,
  from: `From`,
  to: `To`,
  apply: `Apply`,
  promotions: `Promotions`,
  learn_more: `LEARN MORE`,
  password_doesnt_match: `Password doesn't match`,
  cancel: `Cancel`,
  confirm_to_pay: `Confirm To Pay`,
  deposit_amount: `Deposit Amount`,
  loading_please_wait: `Loading, Please Wait`,
  account: `Account`,
  profile: `Profile`,
  bank_list: `Bank List`,
  in_maintenance: `In Maintenance`,
  birthday: `Birthday`,
  birthday_bonus: `Enter your birthday for a bonus! 🎉🎁`,
  referral_code: `Referral Code`,
  friend_referral_code: 'Friend referral code',
  no_friend: '( keep it blank if no friend )',
  referral: `Referral`,
  my_referral: `My Referral`,
  my_claim: `My Claim`,
  claim_profit: `CLAIM PROFIT`,
  available_profit: `Available Profit`,
  claimed_profit: `Claimed Profit`,
  all_time_profit: `All Time Profit`,
  referral_note_on_x: `Earn profit every time your friends playing on {{x}}`,
  tier: `Tier`,
  commission: `Commission`,
  referred_member: `Referred Member`,
  profit_earned: `Profit Earned`,
  account_information: `Account Information`,
  invite_friends: `Invite Friends`,
  how_it_work: `How it work?`,
  invite_note: `Get exclusive referral bonuses when your friend signs up using your referral code!`,
  share_via: `Share via`,
  referral_link: `Referral Link`,
  total_profit: `Total Profit`,
  copied: `Copied`,
  nothing_to_claim: `Nothing to claim`,
  claim_history: `Claim History`,
  downline: `My Downline`,
  last_x_digit_bank_ref_number: `Last {{x}} digit of Bank Ref number`,
  bank_ref_number_validation_x: `Bank Ref Number is required and must be {{x}} character length`,
  sort: 'Sort',
  login_directly: `Login directly with`,
  our_game_provides: `OUR GAME PROVIDERS`,
  refer_and_reward: `Refer & Reward`,
  linked_successfully_x: `Linked successfully with {{x}}! Please register your account for the first time`,
  more_x_of_y: `More {{x}}/{{y}}`,
  default: `Default`,
  promotion: `Promotion`,
  daily_mission: 'Daily Mission',
  agent: 'Agent',
  contact_us: 'Contact Us',
  download: 'Download',
  cash_claim: 'Cash Claim',
  demo: 'Demo',
  favorites: 'Favorites',
  popular: 'Popular',
  claim_bonus: `Claim Bonus`,
  insufficient_balance: `Insufficient Balance`,
  currently_displaying: 'Currently displaying {{x}} {{y}} games out of {{z}}',
  all_x: 'All {{x}}',
  no_results: 'No Results Found',
  search_games: 'Search Games',
  please_scan_using_your: `Please scan using your`,
  vip_level: `VIP Level`,
  bonus_direct: `BONUS DIRECT`,
  rebate_level: `Rebate Level`,
  vip_header: `All bets placed on Slot Machines, Board and Card Games, Fishing, Videos, Sports and Lottery Games at BD888 will be accumulated permanently. Valid bets = Permanent Income and Money Fortune!`,
  vip_example: `
  Example 1: Members who reach 1 Million in accumulated deposits, reach VIP Level 2, receive a bonus of R$210,and Rebate 3.50%, When they reach 6 Million in accumulated deposit, they reach VIP Level 3 and receive a bonus of R$800, with a Rebate 4%`,
  activity_rules: `Activity Rules:`,
  activity_rules_1: `1. It is necessary for all bonuses to have x3 Rollover to request the Withdrawal`,
  activity_rules_2: `2. Please claim the Rebate Bonus within the deadline, if you happen to be late, it will be considered abandonment;`,
  activity_rules_3: `3. Members' participation in activities is automatically counted by the system, if there is any objection, the result of BD888's investigation will prevail;`,
  activity_rules_4: `4. If you forget your member Account/Password, please contact "24-hour Online Customer Service" to help you recover your account information;`,
  activity_rules_5: `5. BD888 reserves the right to change, stop or cancel this promotion at any time.`,
  activity_rules_6: `6. Do not save free game , Buy free game`,
  activity_rules_7: `7. Can't combine with any bonus`,
  activity_rules_8: `8. Maximum Withdraw per Deposit is R$100.000.00`,
  event_instructions: 'Event Instructions',
  agent_p1: 'Share your unique link across apps and social media',
  agent_p2:
    'Facebook, Instagram, Tiktok, Telegram, WhatsApp, YouTube, among others, hurry up and invite everyone, members who register through your exclusive link will become your direct agents. But pay attention because the new members you invite must be genuine and valid.',
  agent_step1:
    'Get invitation friend the first deposit is successful, you can win a bonus of R$5. for example, if you invite 10 people for the first deposit, you can earn R$50. The more people you invite, the more bonuses you will receive. You can view your history and register on the promotion pageonuses and high commissions.',
  agent_step2:
    "If your guests bet R$1 or more, you can already enjoy high commission! You can earn up to 5% lifetime commission, and an invitation for life! The system will settle the previous day's commission at 7am the following day.",
  agent_step2_1: 'How to get: Login - Invitation promotion - Collect commission',
  agent_table1: 'Betting commission rates for slot, fishing and blockchain are as follows:',
  agent_table1_1: 'The customer topup 20 bet 200',
  person: 'person',
  agent_table2_title1: 'Member Betting',
  agent_table2_title2: 'Slot Game Only',
  agent_table2_example:
    'Example: You have 100 members, and the total real value of bets is estimated at 1 million reais per day. The commission you receive that day is: 1,000,000 x 1.20% 12,000 reais. A monthly income of 100,000 is super easy to achieve.',
  reminder: 'Reminder',
  agent_reminder:
    'A member account with the same IP, same device, name, bank card and other information can only participate once, and anyone who violates the rules will not benefit from this bonus. or the group will be confiscated and accounts will be permanently frozen',
  agent_step3_1:
    'The participation of members in activities is automatically counted by the system, if there is any objection, the result of the analysis carried out by BD888 will prevail',
  agent_step3_2:
    'If you forget your member account/password, please contact our 24-hour customer service team to help you recover your account information',
  agent_step3_3: 'BD888 reserves the right to change, interrupt or cancel the promotion at any time',
  agent_step3_4: 'Agent able to received the comission bonus is term of cash or credits in wallet',
  agent_step3_5: 'Do not save free game, Buy free game',
  agent_step3_6: "Can't combine with any bonus and deposit",
  agent_step3_7: 'Only available for Slot game',
  promo_concluded: 'Promo has concluded! Check back again tomorrow!',
  can_only_claim: 'Can only claim bonus between {{x}} to {{y}} Brazil Time',
  please_login: 'Please Login first to claim the bonus!',
  back_to_home: 'Back to Home',
  bonus_claimed: 'Bonus Already Claimed!',
  settings: 'settings',
  logging_in: 'Logging in....',
  network_error: 'Network Error',
  we_have_sent_otp: 'We have sent an OTP to your phone number',
  your_otp_expire: 'Your OTP will expire in',
  didnt_receive: "Didn't receive the message?",
  send_again: 'Send Again',
  resend_again: 'Resend again in',
  invalid_verification: 'Invalid Verification Code!',
  otp_expired: 'OTP expired, please reenter your phone number and try again!',
  otp_expired_redirect: 'OTP expired! redirecting to login',
  captcha_check_failed: 'Captcha Check Failed!',
  verify_phonenumber: 'Verify Phone Number',
  send_otp: 'Send OTP',
  success_verification: 'Your Phone Number has been verified!',
  press_get_code: 'Press GET CODE Button To Receive Verification Code Via SMS',
  otp_sent: 'Verification Code Sent! Enter the verification code below to continue',
  get_code: 'Get Code',
  verify: 'Verify',
  verification_code: 'Verification Code',
  otp_not_found: 'OTP Function Not Found!',
  yes: `Yes`,
  no: `No`,
  please_register_to_claim_bonus: `Please Register to claim bonus!`,
  home: `Home`,
  no_announcement_for_moment: `'No announcement for a moment'`,
  no_games_found: `No Games Found`,
  history: `History`,
  live_transactions: `Live Transactions`,
  live: `Live`,
  categories: `Categories`,
  x_categories: '{{x}} Categories',
  x_category: '{{x}} Category',
  live_chat: `Live Chat`,
  invite_friend: 'Invite Friends',
  copy_referral_link: 'Copy Referral Link',
  balance: 'Balance',
  level: 'Level',
  dl_apk_test: `DL APK Test`,
  affiliates: `Affiliates`,
  menu: 'Menu',
  promo_center: 'Promo Center',
  refresh: 'Refresh',
  password: 'Password',
  password_placeholder: '6 - 20 characters',
  optional: '(optional)',
  login_here: 'Login Here',
  enter_text_on_the_left: 'Enter text on the left',
  more_info: 'More Info',
  back: 'Back',
  number_exists: 'This phone number is already registered!',
  number_not_exists: 'This phone number is not registered!',
  please_download_x_to_play: 'Please download {{x}} to play',
  play_now: 'Play Now',
  daily_rebate: 'Daily Rebate',
  logout_confirmation: 'Logout Confirmation',
  are_you_sure_to_logout: 'Are you sure you want to logout?',
  desposit_from_bank: 'Deposit From Bank',
  dont_show_again: "Don't show again",
  must_start_with: `Must start with (010, 011, 012, 013, 014, 015, 016, 017, 018, 019)`,
  password_must_be_6_to_20: `Password must be 6 - 20 in length`,
  no_balance: 'No Balance',
  maximum_withdraw_amount_is_x: `Maximum Withdraw Amount is {{x}}`,
  change_language: 'Change Language',
  for_all_categories: 'For all Categories',
  register_with_telegram: 'Register with Telegram',
  registration_method: 'Registration Method',
  e_games: 'E-Games',
  card: 'Card',
  instant: 'Instant',
  no_games_available: 'No games available at the moment',
  affiliate: `Affiliate`,
  info_center: `Info Center`,
  language: `Language`,
  sort_a_z: `Name A - Z`,
  sort_z_a: `Name Z - A`,
  lucky_spin: `Lucky Spin`,
  search_game: `Search game...`,
  favourite: `Favourite`,
  hi: `Hi`,
  facebook: `Facebook`,
  whatsapp: `Whatsapp`,
  messenger: `Messenger`,
  pinterest: `Pinterest`,
  refer_and_earn: `Refer and Earn`,
  angpow: `Angpow`,
  join_x: 'Join {{x}}',
  reg_instruction_1: 'Click the button below to send "Join BD888" to our telegram account',
  reg_instruction_2: 'Press "Share My Contact" from telegram to send your phone number to proceed with registration',
  reg_instruction_3: 'Please wait 1 minute',
  reg_instruction_4: 'Login with your Telegram phone number and the password is 000000',
  reg_instruction_5: 'Change password after login',
  reg_instruction_6: 'Please use your real name and account number when registering',
  input_otp: 'Please input OTP',
  send_again_in_x: 'Send again in {{x}}',
  otp_sent_enter_code_password: 'Verification code sent. Please enter the code and your new password below',
  win: 'Win',
  bet: 'Bet',
  payout_ratio: 'Payout Ratio',
  rank: 'Rank',
  leaderboard: 'Leaderboard',
  popular_games: 'Popular Games',
  nothing_to_show: 'Nothing to show',
  minimum_deposit: 'Minimum Deposit',
  minimum_withdraw: 'Minimum Withdraw',
  maximum_deposit: 'Maximum Deposit',
  maximum_withdraw: 'Maximum Withdraw',
  clear_balance: 'Clear Balance',
  this_will_set_balance: 'This will set your balance to zero, continue?',
  min_max_withdraw_will_reset: 'Minimum / Maximum withdrawal will be reset after withdrawal or balance is empty',
  providers: 'Providers',
  next: `Next`,
  close: `Close`,
  no_data: `No Data`,
  add: `Add`,
  remarks: `Remarks`,
  join_us_for_latest: `JOIN US FOR LATEST`,
  join_content: `INFO / NEW BONUS / FREE CREDIT`,
  subscribe: `SUBSCRIBE`,
  play: `Play`,
  recent_games: 'Recent Games',
  you_won_x: 'You won {{x}}',
  coins: 'Coins',
  spin: 'Spin',
  congratulations: 'Congratulations',
  continue: 'Continue',
  insufficient_points: 'Insufficient Points',
  nice_try: 'Nice Try',
  points_required: 'Points Required',
  no_promotions_available: 'No Promotion Available',
  outstanding_feature: 'Outstanding Feature',

  prestigous_brand: 'Prestigous Brand',
  prestigous_brand_chosen: 'Prestigious brand chosen by many people',

  product_diversity: 'Product Diversity',
  online_casino_sports:
    'Online Casino, Sports, Slots, Fish Shooting, Cockfighting... Many diverse products you can choose from.',

  security_privacy: 'Security and Privacy',
  diverse_payment: 'Diverse payment methods, ensuring high safety and security.',

  fast_transaction: 'Fast Transactions',
  deposit_transaction_process:
    'Deposit transactions are processed within 1-3 minutes upon receipt of transfer. Withdrawal time within 3-5 minutes.',
  username_must_start_with: 'Username must start with {{x}}',
  phone_number_must_start_with: 'Phone number must start with {{x}}',

  vip_club: 'VIP Club',
  vip_benefits: 'VIP Benefits',
  o_limits: 'No Limits',
  no_limits_description:
    "We offer personal VIP services with unique gaming conditions to all players in the VIP club. Now you can play without any worries! It's very simple - play for the thrill, improve your gaming skills, enjoy your time and get no limits on your winnings opportunities!",
  financial_privileges: 'Financial Privileges',
  financial_privileges_description:
    "VIP club welcomes all players who want to get high-quality VIP service. Exclusive privileges, special promotions and benefits are available for you at our Website! VIP player's status unlocks higher withdrawal limits of funds in record-breaking short terms! Enjoy it!",
  personal_manager: 'Personal Manager',
  personal_manager_description:
    'Which of the advantages would you like to get when you become a VIP player? Share your thoughts with your personal manager and let us know what more you would be happy to see at our Website! We are always open for great suggestions!',
  vip_promotions: 'VIP Promotions',
  vip_promotions_description:
    'Would you like to get more great promotions, hefty VIP players enjoy all these and many more perks as a reward for the loyalty! Be on of them!',
  become_vip: 'Become A VIP',
  max_withdrawal: `Max Withdrawal`,
  no_limits: 'No Limits',
  total_deposit: 'Total Deposit',
  daily_withdraw_limit: 'Daily Withdraw Limit',
  transaction_counts: 'Transaction Counts',
  vip_birthday_bonus: 'VIP Birthday Bonus',

  user_profile: 'User Profile',
  member_group: 'Member Group',

  no_categories_available: 'No Categories Available',
  showing: 'Showing',
  clear_filters: 'Clear Filters',
  filter_date: 'Filter Date',

  bet_now: 'BET NOW',
  join_now: 'JOIN NOW',
  new_member: `New Member`,
  all_promotion: `All Promotion`,
  vip: `VIP`,
  special: `Special`,
  credit: `Credit`,
  login_now: `Login Now`,
  withdraw_amount: `Withdraw Amount`,
  bank_details: `Bank Details`,
  create_an_account: `Create an account`,
  security_center: `Security Center`,
  about_bd888: `About BD888`,
  bd888_license_desc: `BD888 is licensed and regulated by the Government of Curaçao and operates under the master license of Gaming Services Provider N.V.`,
  gaming_license: `Gaming License`,
  information: `Information`,
  about_us_title: `About Us`,
  terms_and_conditions: `Terms and Conditions`,
  privacy_policy_title: `Privacy Policy`,
  responsible_gaming_title: `Responsible Gaming`,
  disconnect_policy: `Disconnect Policy`,
  help_center: `Help Center`,
  certification: `Certification`,
  review_us_on: `Review us on`,
  follow_us: `Follow Us`,
  security: `Security`,
  show_less: `Show Less`,
  show_more: `Show More`,
  footer_seo_title: 'BD888 Casino | Trusted Online Casino Bangladesh | Sign Up No Deposit Bonus 2025',
  footer_seo_intro:
    "If you're searching for a reliable, secure, and rewarding online casino in Bangladesh, look no further than BD888 Casino. Designed specifically for Bangladeshi players, BD888 offers a smooth and localized gaming experience with full support for bKash, Nagad, Rocket, and other local payment methods. And best of all — you can get started with a sign up no deposit bonus 2025, with no upfront payment required.",
  footer_seo_why_title: 'Why Casino Players Choose BD888?',
  footer_seo_secure_title: 'Secure & Licensed Online Casino',
  footer_seo_secure_description:
    'BD888 Casino is fully licensed under the Government of Curaçao (license no. 365/JAZ), providing a safe and fair environment for all players. All games are independently certified by top testing agencies like iTech Labs and BMM, ensuring that every spin and card dealt is 100% fair.',
  footer_seo_bonus_title: 'Instant No Deposit Bonus 2025',
  footer_seo_bonus_description:
    'New to BD888? Great news — you don’t even need to deposit money to get started. With the sign up no deposit bonus 2026, new users can register and instantly receive a bonus to try out their favorite games risk-free.',
  footer_seo_payment_title: 'Local Payment Methods (bKash, Nagad, Rocket)',
  footer_seo_payment_description:
    'BD888 is optimized for the Bangladeshi market, supporting fast and secure transactions through bKash, Nagad, Rocket, and other regional gateways. Withdrawals are quick, with minimal hassle.',
  footer_seo_support_title: '24/7 BD888 Customer Support',
  footer_seo_support_description:
    'Got a question or facing a technical issue? BD888 offers round-the-clock Bangla-speaking customer support via live chat and email, ensuring you’re never left in the dark.',
  footer_seo_games_title: 'The Best Recommended Online Casino Games at BD888',
  footer_seo_games_description:
    'BD888 Online Casino Bangladesh boasts a massive portfolio of exciting games that cater to every player type.',
  footer_seo_slots_title: 'Slot Games',
  footer_seo_slots_description:
    'Choose from top providers like Pragmatic Play, PG Soft, and JILI. Whether you like classic slots or high-volatility jackpots, BD888 online slots has something for you to win huge jackpots with our sign up no deposit bonuses.',
  footer_seo_live_casino_title: 'Live Casino',
  footer_seo_live_casino_description:
    'Play in real-time with professional dealers in games like Roulette, Baccarat, and Andar Bahar.',
  footer_seo_sports_betting_title: 'Sports Betting',
  footer_seo_sports_betting_description:
    'Bet live on cricket, football, and other popular sports, with competitive odds and a smooth interface.',
  footer_seo_get_started_title: 'How to Get Started on BD888',
  footer_seo_get_started_description:
    'Joining BD888 Casino is easy. Follow these simple steps to start playing within minutes:',
  footer_seo_step_1: 'Register your account at BD888 via the official website.',
  footer_seo_step_2: 'Verify your mobile number or email address for account security.',
  footer_seo_step_3: 'Claim your no deposit bonus – it’s automatically credited after verification.',
  footer_seo_step_4: 'Start playing slots, live games, or sports betting with your bonus credits.',
  footer_seo_note: 'Note: No deposit needed. Just sign up and enjoy.',
  footer_seo_promotions_title: 'BD888 Casino Bonuses and Promotions',
  footer_seo_promotions_description:
    'BD888 Casino promotions and rewards its players with consistent and valuable promotions:',
  footer_seo_promo_1_title: 'No Deposit Sign-Up Bonus',
  footer_seo_promo_1_description: 'Get started without spending anything.',
  footer_seo_promo_2_title: 'Daily Reload Bonuses',
  footer_seo_promo_2_description: 'Boost your balance every day with match bonuses.',
  footer_seo_promo_3_title: 'Referral Program',
  footer_seo_promo_3_description: 'Invite your friends and get extra credits when they join.',
  footer_seo_promo_4_title: 'VIP & Loyalty Rewards',
  footer_seo_promo_4_description:
    'High rollers and loyal players enjoy exclusive perks, including cashback, special promotions, and priority withdrawals.',
  footer_seo_promo_4_note: 'BD888 ensures every player, whether new or returning, feels appreciated.',
  footer_seo_faq_title: 'FAQs',
  footer_seo_faq_1_question: '1) Is BD888 casino legal in Bangladesh?',
  footer_seo_faq_1_answer:
    'BD888 is operated under an international license (Curaçao eGaming) and is accessible to Bangladeshi users. All operations comply with international gambling standards.',
  footer_seo_faq_2_question: '2) How to claim the sign up no deposit bonus?',
  footer_seo_faq_2_answer:
    'Just register on BD888, verify your account, and the bonus will be credited automatically — no deposit needed.',
  footer_seo_faq_3_question: '3) What makes BD888 the best online casino in Bangladesh?',
  footer_seo_faq_3_answer:
    'Local payment support, 24/7 Bangla support, a wide range of games, fast payouts, and generous bonuses make BD888 the top choice for Bangladeshi players.',

  member_privilege: `Member Privilege`,
  accumulated_deposit: `Accumulated Deposit`,
  upgrade_vip_points: `Upgrade VIP Bonus`,
  upgrade_bonus: `Upgrade Bonus`,
  month_bonus: `Month Bonus`,
  upgraded_vip_points: `Upgraded VIP points`,
  referral_affilate: `Referral / Affiliate Code`,
  terms_and_services: `I am 18 years old and have read Terms & Service and Privacy Policy`,
  please_enter_code: `Please Enter Code`,
  create_your_account: `Create your account`,
  or_return_to_login: `or return to Login`,
  kyc_verification: `KYC Verification`,
  kyc_not_verified: `Your account must be KYC verified before you can make a withdrawal. If you have already submitted your KYC, please wait for our CS to verify your account.`,
  proceed: `Proceed`,
  nid_number: `NID Number`,
  nid_front: `NID Front`,
  selfie_photo_with_nid: `Selfie Photo with NID`,
  kyc_submitted: `KYC Submitted`,
  verified: `Verified`,
  unverified: `Unverified`,
  become_agent: `Become Agent`,
  telegram_channel: `Telegram Channel`,
  download_message: `Download our app today!`,
  verified_by_play_protect: `Verified by Play Protect`,
  reviews: `26K reviews`,
  reviews_value: `4M+`,
  downloads: `Downloads`,
  rated_for: `Rated for 18+`,
  install: `Install`,
  add_to_wishlist: `Add to wishlist`,
  about_this_app: `About this app`,
  app_description_1: `Welcome to BD888, Bangladesh's premier online casino platform, where excitement and winning
              opportunities never stop! Whether you're a fan of classic casino games or modern, high-stakes betting, we
              offer something for everyone. Experience the thrill of our wide range of games, including slots,
              blackjack, roulette, poker, and more—all from the comfort of your mobile device.`,
  app_description_2: `At BD888, we prioritize your safety and gaming experience. Our platform is fully licensed and secure,
              ensuring fair play and responsible gaming at all times. We use advanced technology to protect your
              personal information and provide a seamless gaming experience with fast deposits, quick withdrawals, and
              24/7 customer support.`,
  why_choose_brand: `Why choose BD888?`,
  reason_1: `A vast selection of games from top game providers`,
  reason_2: `User-friendly interface with easy navigation`,
  reason_3: `Exclusive bonuses and promotions tailored just for you`,
  reason_4: `Secure payment options for fast and safe transactions`,
  reason_5: `Available in Bengali and English to suit your preference`,
  app_description_3: `Join thousands of satisfied players today and take part in Bangladesh's most trusted online casino
              experience! Whether you're here for the thrill of the game or the chance to win big, BD888 is your
              gateway to endless entertainment.`,
  app_download: `App Download`,
  verification_code_sent: 'Verification code has been sent to {{x}}',
  resend_code_in: 'Resend code in',
  send_code: 'Send Code',
  // TODO: Translate to other lang
};
export default en;
